import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M3.34,12.87a.47.47,0,0,1-.12-.09l-.09-.11ZM14.74,8a6.73,6.73,0,0,1-11.4,4.87l-.21-.2h0A6.74,6.74,0,1,1,14.74,8Zm-12,0a5.18,5.18,0,0,0,1,3.14l7.33-7.33A5.17,5.17,0,0,0,8,2.76,5.25,5.25,0,0,0,2.75,8ZM13.24,8a5.17,5.17,0,0,0-1.05-3.13L4.86,12.2A5.18,5.18,0,0,0,8,13.25,5.25,5.25,0,0,0,13.24,8Z';
const draw24px =
  'M5.25,19a.42.42,0,0,1-.16-.11A.59.59,0,0,1,5,18.73Zm16.5-7A9.76,9.76,0,0,1,12,21.75,9.64,9.64,0,0,1,5.25,19L5,18.73A9.74,9.74,0,0,1,12,2.25,9.77,9.77,0,0,1,21.75,12Zm-18,0a8.23,8.23,0,0,0,1.91,5.28L17.27,5.67A8.17,8.17,0,0,0,12,3.75,8.26,8.26,0,0,0,3.75,12Zm16.5,0a8.17,8.17,0,0,0-1.92-5.27L6.72,18.34A8.25,8.25,0,0,0,20.25,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const AlertErrorIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'alertError'),
) as IconWithRender;

AlertErrorIcon.displayName = 'AlertErrorIcon';
AlertErrorIcon.propTypes = Icon.propTypes;
AlertErrorIcon.renderIcon = (props) => <AlertErrorIcon {...props} />;
export default AlertErrorIcon;
